<div>
  <div class="row mt-3">
    <div class="col-9">
      <div class="mb-3 d-flex justify-content-between">
        <h2 class="title-list">List of Distributor Staff Users</h2>
      </div>
    </div>
    <div class="col-3 text-end">
      <div class="d-flex justify-content-end">
        <div>
          <button *ngIf="
                    permissionsService.editPermission && !readOnly
                  " class="btn btn-info" 
                  (click)="navigateToDistributorUsers()"
             appTooltip="Assign Distributor Staff">
            <i class="bi bi-person-plus" ></i>
          </button>
        </div>

 
      </div>
    </div>
  </div>

  <div>
    <app-table-control [data]="distributorStaffList" 
                       [columns]="columns" 
                       [pageSize]="5" 
                       [showCheckboxes]="true"
                       [actionButtons]="actionButtons" 
                       [showActions]="!readOnly && permissionsService.editPermission" 
                       (actionClick)="onAction($event)" 
                       [showCheckboxes]="false">
    </app-table-control>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="modalSwitch" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
              Distributor Staff User Active/Inactive
            </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updateUserStatus(false)"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this Distributor Staff User?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalArchive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="d-flex align-items-center justify-content-center full-height">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
              Distributor Staff User Archive
            </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="updateUserStatus(false)"></button>
        </div>
        <div class="modal-body">
            Are you sure you want to Archive the Distributor Staff User <strong>{{ selectedStaffUser.userNames }}</strong>?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="updateUserStatus(false)">
            Close
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateUserStatus(true)">
            Yes, Archive
          </button>
        </div>
      </div>
    </div>
  </div>
</div>